import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { IonContent, IonPage } from '@ionic/react';
import { ArrowLeft } from 'lucide-react';
import { PlatformFeature } from '../api';
import ProFeature from '../components/ProFeature';
import { Button } from '../components/ui/button';

type ProSubscriptionLocationState = {
  returnTo?: string;
};

const isInternalAppPath = (value: unknown): value is string =>
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//');

const ProSubscription: React.FC = () => {
  const history = useHistory();
  const location = useLocation<ProSubscriptionLocationState | undefined>();
  const { t } = useTranslation();

  const returnToApp = useCallback(() => {
    const returnToState = location.state?.returnTo;
    const returnTo = isInternalAppPath(returnToState)
      ? returnToState
      : '/dashboard';

    history.push(returnTo);
  }, [history, location.state]);

  return (
    <IonPage>
      <IonContent fullscreen className="bg-gradient-to-br from-slate-50 via-stone-100 to-gray-100">
        <div className="min-h-screen px-4 py-5 md:py-8">
          <div className="mx-auto mb-4 flex max-w-4xl justify-start">
            <Button
              variant="outline"
              className="border-stone-300 bg-white/80 text-slate-700 hover:bg-stone-50"
              onClick={returnToApp}
              aria-label={t('goBack')}
            >
              <ArrowLeft className="h-4 w-4" />
              {t('goBack')}
            </Button>
          </div>

          <ProFeature feature={PlatformFeature.AiChat}>
            <Redirect to="/dashboard" />
          </ProFeature>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ProSubscription;
